questionFlow = {}
questionFlow.inPerson1 = {
  title: "VOTING IS ALWAYS IN STYLE",
  questions: [
    '',
    '',
    'ARTICLE OF CLOTHING (PLURAL)',
    'COLOR',
    'ADJECTIVE',
    'ANIMAL',
    'PREFERRED VOTING TIME',
    'FAVORITE MUSICIAN/BAND',
    'POLLING PLACE LOCATION <u><a style="color:#002CA9" class="question-text-blue" href="https://www.headcount.org/find-your-polling-place/" target="_blank">(Not Sure? Click Here)</a></u>',
    'PERSON IN THE ROOM',
    'METHOD OF TRANSPORTATION TO THE POLLS',
    'NUMBER',
    'VERB ENDING IN "ING"',
    'ADJECTIVE',
    'VERB',
    'YOUR FIRST NAME',
    'YOUR EMAIL',
    'YOUR PHONE NUMBER',
    'YOUR ZIP CODE'
  ],
  endStory: [
    'Forget denim ',
    'ARTICLE OF CLOTHING (PLURAL)',
    ' and ',
    'COLOR ',
    ' boots. This season’s must-have fashion accessory is the ',
    'ADJECTIVE',
    ' “I Voted” sticker. But don’t worry -- getting your hands on this hot little item is as easy as 1, 2, 3. </br></br>Are you an early bird or a night ',
    'ANIMAL',
    '? Most polling locations open early and stay open fashionably late, so you can cast your vote at ',
    'PREFERRED VOTING TIME',
    ', or whenever it suits you best. </br></br>You can be as fashionable as ',
    'FAVORITE MUSICIAN/BAND',
    ' this election season. Schools, colleges, and churches are common polling sites, and your polling location is ',
    'POLLING PLACE LOCATION',
    ' so vote like a boss and get yourself a sticker. </br></br> You and ',
    'PERSON IN THE ROOM',
    ' can roll up to your polling location in style. Bus, train, or ',
    'METHOD OF TRANSPORTATION TO THE POLLS',
    ' are great ways to get to the polls. (But a ',
    'NUMBER',
    '-foot stretch limousine works in a pinch). Voting, like shopping and ',
    'VERB ENDING in "ING"',
    ', is best done with friends. Get yourself to the polls and rock your I Voted stickers in style. Politics can be ',
    'ADJECTIVE',
    '. But when you participate in democracy, you ',
    'VERB',
    ' the world.'

  ],
  export: ['Forget denim ',
  'ARTICLE OF CLOTHING (PLURAL)',
  ' and ',
  'COLOR ',
  ' boots. This season’s must-have fashion accessory is the ',
  'ADJECTIVE',
  ' “I Voted” sticker.'],
  export2: ['Forget denim ',
  'ARTICLE OF CLOTHING (PLURAL)',
  ' and ',
  'COLOR ',
  ' boots. This season’s must-have fashion accessory is the ',
  'ADJECTIVE',
  ' “I Voted” sticker.</br></br>Are you an early bird or a night ',
  'ANIMAL',
  '? Most polling locations open early and stay open fashionably late, so you can cast your vote at ',
  'PREFERRED VOTING TIME',
  ', or whenever it suits you best.']
}
questionFlow.inPerson2 = {
  title: "WHO SHOULD I VOTE FOR?",
  questions: [
    '',
    '',
    'FAVORITE MUSICIAN/BAND',
    'VERB ENDING in "ING"',
    'ISSUE YOU CARE ABOUT',
    'COLOR',
    'PLURAL NOUN',
    'METHOD OF TRANSPORTATION TO THE POLLS',
    'PLURAL NOUN',
    'POLLING PLACE LOCATION <u><a style="color:#002CA9" class="question-text-blue" href="https://www.headcount.org/find-your-polling-place/" target="_blank">(Not Sure? Click Here)</a></u>',
    'PREFERRED VOTING TIME',
    'ADJECTIVE',
    'VERB ENDING in "ING"',
    'PERSON IN ROOM',
    'YOUR FIRST NAME',
    'YOUR EMAIL',
    'YOUR PHONE NUMBER',
    'YOUR ZIP CODE'
  ],
  endStory: [
    'Sometimes I think ',
    'FAVORITE MUSICIAN/BAND',
    ' would be the best candidate. But I’m going to do some research and find out about everyone who is actually ',
    'VERB ENDING in "ING"',
    ' for office. <br/><br/>I want to know where each one stands on ',
    'ISSUE YOU CARE ABOUT',
    '. I usually vote ',
    'COLOR',
    ' but might do something different this time if a candidate cares as much about ',
    'PLURAL NOUN',
    ' as I do. <br/><br/>On Election Day, I will travel to the polls by',
    'METHOD OF TRANSPORTATION TO THE POLLS',
    ' and vote to save the ',
    'PLURAL NOUN',
    '.<br/><br/> When I get to ',
    'POLLING LOCATION (DON’T KNOW, CLICK HERE)',
    ' at ',
    'PREFERRED VOTING TIME',
    ', I will stop and take it all in. It makes me feel ',
    'ADJECTIVE',
    ' because I love ',
    'VERB ENDING in "ING"',
    ' in democracy. The candidates are never perfect, but they’re still better than ',
    'PERSON IN THE ROOM',
    ' being in charge.'
  ],
  export: [
    'Sometimes I think ',
    'FAVORITE MUSICIAN/BAND',
    ' would be the best candidate. But I’m going to do some research and find out about everyone who is actually ',
    'VERB ENDING in "ING"',
    ' for office.'],
    export2: [
        'Sometimes I think ',
        'FAVORITE MUSICIAN/BAND',
        ' would be the best candidate. But I’m going to do some research and find out about everyone who is actually ',
        'VERB ENDING in "ING"',
        ' for office. <br/><br/>I want to know where each one stands on ',
        'ISSUE YOU CARE ABOUT',
        '. I usually vote ',
        'COLOR',
        ' but might do something different this time if a candidate cares as much about ',
        'PLURAL NOUN',
        ' as I do.']
}
questionFlow.inPerson3 = {
  title: 'ELECTION DAY CHECKLIST',
  questions: [
    '',
    '',
    'EXCLAMATION',
    'FAVORITE MUSICIAN/BAND' ,
    'TYPE OF FOOD',
 'PERSON IN ROOM' ,
'VERB',
'PREFERRED VOTING TIME',
'POLLING PLACE LOCATION <u><a style="color:#002CA9" class="" href="https://www.headcount.org/find-your-polling-place/" target="_blank">(Don\'t Know? Click Here)</a></u>',
'METHOD OF TRANSPORTATION TO THE POLLS',
'NOUN',
'ISSUE YOU CARE ABOUT',
'ADJECTIVE',
'PLURAL NOUN',
'YOUR FIRST NAME',

'YOUR EMAIL',
'YOUR PHONE NUMBER',
'YOUR ZIP CODE'
  ],
  endStory: [
    '',
    'EXCLAMATION',
    '! It’s Election Day 2018! I’m so excited to go to the polls and cast my ballot. But first, let me put on my favorite song by ',
    'FAVORITE MUSICIAN/BAND',
    ' to face the day! <br/><br/>Then, I’ll eat a bowl of ',
    'TYPE OF FOOD',
    ' so I have lots of energy for today. Next, I’ll call ',
    'PERSON IN ROOM',
    ' and get them to ',
    'VERB',
    ' to the polls with me. We should try to get there around ',
    'PREFERRED VOTING TIME',
    '. <br/><br/>The best way to get to ',
    'POLLING PLACE LOCATION',
    ' is by ',
    'METHOD OF TRANSPORTATION TO THE POLLS',
    '. It’s so easy, even a/an ',
    'NOUN',
    ' could do it!<br/><br/>',
    'ISSUE YOU CARE ABOUT',
    ' is/are very important to me, and I want to vote for a/an ',
    'ADJECTIVE',
    ' candidate who feels the same way. After I vote, I’ll snap a selfie with my “I Voted” sticker. I always post it on social media to show my ',
    'PLURAL NOUN',
    ' that voting is cool.'

  ],
  export: ['EXCLAMATION',
  '! It’s Election Day 2018! I’m so excited to go to the polls and cast my ballot. But first, let me put on my favorite song by ',
  'FAVORITE MUSICIAN/BAND',
  ' to face the day!'],
  export2: ['EXCLAMATION',
  '! It’s Election Day 2018! I’m so excited to go to the polls and cast my ballot. But first, let me put on my favorite song by ',
  'FAVORITE MUSICIAN/BAND',
  ' to face the day! <br/><br/>Then, I’ll eat a bowl of ',
  'TYPE OF FOOD',
  ' so I have lots of energy for today. Next, I’ll call ',
  'PERSON IN ROOM',
  ' and get them to ',
  'VERB',
  ' to the polls with me. We should try to get there around ',
  'PREFERRED VOTING TIME',
'.']
}

questionFlow.mail1 = {
  title: 'MAIL IT, JUST MAIL IT',
  questions: [
    '',
    '',
    'NOUN',
    'VERB ENDING IN “ING”',
    'ARTICLE OF CLOTHING',
    'ISSUE YOU CARE ABOUT',
    'PERSON IN THE ROOM',
    'WHERE YOU MAIL THINGS',
    'DAY OF THE WEEK',
    'EXCLAMATION',
    'PART OF THE BODY',
    'YOUR FIRST NAME',

    'YOUR EMAIL',
    'YOUR PHONE NUMBER',
    'YOUR ZIP CODE'
  ],
 endStory:[
   'I prefer voting in the privacy of my own ',
   'NOUN',
   '. Instead of putting on clothes and ',
   'VERB ENDING in "ING"',
   ' through the crowds in person, I get to cast my ballot wearing nothing but my ',
   'ARTICLE OF CLOTHING',
   ' and a smile!<br/><br/>First, I log into my computer to find out where the candidates stand on ',
   'ISSUE YOU CARE ABOUT',
   '. I place a stamp on the ballot and convince ',
   'PERSON IN THE ROOM',
   ' to walk down to the ',
   'WHERE YOU MAIL THINGS',
   ' to mail it for me. I’ll definitely mail it in by ',
   'DAY OF THE WEEK',
   ', so it will get counted. <br/><br/>',
   'EXCLAMATION',
   '! I’ve just participated in democracy, and I barely had to lift my little ',
   'PART OF THE BODY',
   '.'
],
export: ['I prefer voting in the privacy of my own ',
'NOUN',
'. Instead of putting on clothes and ',
'VERB ENDING in "ING"',
' through the crowds in person, I get to cast my ballot wearing nothing but my ',
'ARTICLE OF CLOTHING',
' and a smile!'],
export2: ['I prefer voting in the privacy of my own ',
'NOUN',
'. Instead of putting on clothes and ',
'VERB ENDING in "ING"',
' through the crowds in person, I get to cast my ballot wearing nothing but my ',
'ARTICLE OF CLOTHING',
' and a smile!<br/><br/>First, I log into my computer to find out where the candidates stand on ',
'ISSUE YOU CARE ABOUT',
'.']
}
  questionFlow.mail2 = {
  title: "COUNTDOWN TO E-DAY",
  questions: [
    '',
    '',
    'ADJECTIVE',
    'PLURAL NOUN',
    'ADVERB',
    'ANIMAL',
    'WHERE YOU MAIL THINGS',
    'ADJECTIVE',
    'DAY OF THE WEEK',
    'TYPE OF FOOD (PLURAL)',
    'FAVORITE MUSICIAN/BAND',
    'VERB',
    'ISSUE YOU CARE ABOUT',
'YOUR FIRST NAME',
'YOUR EMAIL',
'YOUR PHONE NUMBER',
'YOUR ZIP CODE'
  ],
  endStory: [
    'Democracy doesn’t just start and end on November 6th! We’ve created a/an ',
    'ADJECTIVE',
    ' guide to help you plan for the big day...<br><br>Before Election Day: Registered ',
    'PLURAL NOUN',
    ' receive ballots for the upcoming election. In some states, you’ll receive it in the mail automatically. In other states, you have to get an absentee ballot. <br><br>The Week Before: Fill out your ballot ',
    'ADVERB',
    '. Take your ',
    'ANIMAL',
    ' with you to drop your ballot in the mail at ',
    'WHERE YOU MAIL THINGS',
    ' and feel ',
    'ADJECTIVE',
    ' about participating in our democracy. Make sure you mail it in by ',
    'DAY OF THE WEEK',
    ', so it is counted. </br></br>The Night Of: Get cozy, grab a bowl of ',
    'TYPE OF FOOD (PLURAL)',
    ', turn on a  ',
    'FAVORITE MUSICIAN/BAND',
    ' playlist, and watch as the results come in. Even though the election is over, democracy isn’t. Make sure you get ready to ',
    'VERB',
    ' for ',
    'ISSUE YOU CARE ABOUT',
    '.'

  ],
  export: ['Democracy doesn’t just start and end on November 6th! We’ve created a/an ',
  'ADJECTIVE',
  ' guide to help you plan for the big day...'],
  export2: [
    'Democracy doesn’t just start and end on November 6th! We’ve created a/an ',
    'ADJECTIVE',
    ' guide to help you plan for the big day...<br><br>Before Election Day: Registered ',
    'PLURAL NOUN',
    ' receive ballots for the upcoming election. In some states, you’ll receive it in the mail automatically. In other states, you have to get an absentee ballot. <br><br>The Week Before: Fill out your ballot ',
    'ADVERB',
    '.']
}

questionFlow.early1 = {
  title: "THE EARLY BIRD GETS THE VOTE",
  questions: [
    '',
    '',
    'VERB',
    'TYPE OF FOOD',
    'PLURAL NOUN',
    'ADVERB',
    'VERB ENDING in "ING"',
    'FAVORITE MUSICIAN/BAND',
    'DATE YOU\'LL VOTE EARLY',
    'METHOD OF TRANSPORTATION TO THE POLLS',
    'EARLY VOTING LOCATION <u><a class="question-text-blue" href="https://www.headcount.org/early-voting-and-absentee-voting/" target="_blank">(DON’T KNOW? CLICK HERE)</a></u>',
    'ISSUE YOU CARE ABOUT',
    'ADJECTIVE',
'YOUR FIRST NAME',
'YOUR EMAIL',
'YOUR PHONE NUMBER',
'YOUR ZIP CODE'

  ],
  endStory: [
    'These days, it seems like you can’t ',
    'VERB',
    ' a newspaper without hearing about the next election. One candidate says they can create new jobs at the ',
    'TYPE OF FOOD',
    ' factory. Another says all ',
    'PLURAL NOUN',
    ' should be treated more ',
    'ADVERB',
    '. </br></br>This back-and-forth can go on for days, weeks, or even years. But in many states, you can now vote early! So while everyone else is still ',
    'VERB ENDING in "ING"',
    ' about the election, you can get your vote counted in advance and go back to listening to the new ',
    'FAVORITE MUSICIAN/BAND',
    ' album. You can cast your vote on ',
    'DATE YOU\'LL VOTE EARLY',
    '. </br></br>Instead of waiting in long lines on Election Day, why not hop in',
    'METHOD OF TRANSPORTATION TO THE POLLS',
    ' and head straight to ',
    'EARLY VOTING LOCATION ',
    ' to be ahead of the curve? </br></br>When you get there, you can cast a ballot to support ',
    'ISSUE YOU CARE ABOUT',
    ' and feel really ',
    'ADJECTIVE',
    ' about yourself!'
  ],
  export: [
    'These days, it seems like you can’t ',
    'VERB',
    ' a newspaper without hearing about the next election. One candidate says they can create new jobs at the ',
    'TYPE OF FOOD',
    ' factory.'],
    export2: [
      'These days, it seems like you can’t ',
      'VERB',
      ' a newspaper without hearing about the next election. One candidate says they can create new jobs at the ',
      'TYPE OF FOOD',
      ' factory. Another says all ',
      'PLURAL NOUN',
      ' should be treated more ',
      'ADVERB',
      '. </br></br>This back-and-forth can go on for days, weeks, or even years.'
    ]
}
  questionFlow.early2 = {
    title: "EARLY TO BED, EARLY TO VOTE",
    questions: [
      '',
      '',
      'ADJECTIVE',
      'PART OF THE BODY',
      'ADJECTIVE',
      'PART OF THE BODY (PLURAL)',
      'ADJECTIVE',
      'TYPE OF FOOD',
      'DATE YOU’LL VOTE EARLY',
      'METHOD OF TRANSPORTATION TO THE POLLS',
      'EARLY VOTING LOCATION <u><a style="color:#002CA9" href="https://www.headcount.org/early-voting-and-absentee-voting/" target="_blank">(DON’T KNOW? CLICK HERE)</a></u>',
      'ADJECTIVE',
      'FAVORITE MUSICIAN/BAND',
      'VERB ENDING in "ING"',
'YOUR FIRST NAME',
'YOUR EMAIL',
'YOUR PHONE NUMBER',
'YOUR ZIP CODE'
],
    endStory: [
      'We know the world seems pretty ',
      'ADJECTIVE',
      ' these days. But don’t worry! Voting early is a great way to keep a level ',
      'PART OF THE BODY',
      '. <br><br>In fact, when everyone else is waiting in ',
      'ADJECTIVE',
      ' lines, you can relax and kick up your ',
      'PART OF THE BODY (PLURAL)',
      '. It’s like a reward for being a/an ',
      'ADJECTIVE',
      ' citizen, which tastes better than ',
      'TYPE OF FOOD',
      '. </br></br>On ',
      'DATE YOU’LL VOTE EARLY',
      ', you can take your',
      'METHOD OF TRANSPORTATION TO THE POLLS',
      ' to ',
      'EARLY VOTING LOCATION ',
      ' and cast your ballot before the rush. Then, you can check voting off your list and feel ',
      'ADJECTIVE',
      ' about participating in democracy. </br></br>Once you’ve made your voice heard, you can get back to your favorite activities, like listening to ',
      'FAVORITE MUSICIAN/BAND',
      ' and ',
      'VERB ENDING in "ING"',
      '.'

    ],
    export: ['We know the world seems pretty ',
    'ADJECTIVE',
    ' these days. But don’t worry! Voting early is a great way to keep a level ',
    'PART OF THE BODY',
    '.'],
    export2: ['We know the world seems pretty ',
    'ADJECTIVE',
    ' these days. But don’t worry! Voting early is a great way to keep a level ',
    'PART OF THE BODY',
    '. <br><br>In fact, when everyone else is waiting in ',
    'ADJECTIVE',
    ' lines, you can relax and kick up your ',
    'PART OF THE BODY (PLURAL)',
    '.']
}

module.exports = questionFlow



// WEBPACK FOOTER //
// ./src/questionFlow.js